import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import { useContext, useEffect, useState } from "react";
import { dummyListKategori, dummyListRecommended } from "../dummy-data";
import ProductBox from "../components/ProdukBox";
import KategoriBox from "../components/KategoriBox";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import SearchInputText from "../components/SearchInputText";
import UiContext from "../../../store/ui-context";
import AppContext from "../../../store/app-context";
import { Dropdown } from "primereact/dropdown";
import TokoBoxSmall from "../components/TokoBoxSmall";

const title = "Home";

const HomePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const appContext = useContext(AppContext);
  const uiContext = useContext(UiContext);
  const { requestGet, requestGetOne, requestPost, requestDelete, loading } =
    useAPIRequest();

  const [filterText, setFilterText] = useState("");
  const [listRecommended, setListRecommended] = useState([]);
  const [listKategori, setListKategori] = useState([]);
  const [listToko, setListToko] = useState([]);

  // use effect section

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
    // console.log("FETCH KOSONG");
    // fetchHomeData();
  }, []);

  useEffect(() => {
    if (appContext.selectedKota) {
      fetchHomeData();
    }
  }, [appContext.selectedKota]);

  // api call section

  const fetchHomeData = async () => {
    return requestGet({
      fullUrl: `/api/dashboard/index`,
      params: {
        filter: `kota_id:=:${appContext.selectedKota.id}`,
      },
      onSuccess: ({ pagination, message, data }) => {
        const { produks, produk_kategoris, tokos } = data;
        setListRecommended(produks);
        setListKategori(produk_kategoris);
        setListToko(tokos);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // ui handler section
  const handleSearch = (filterText) => {
    console.log("searching...");
  };

  // custom ui section

  return (
    <div className="col-start-start bg-gray-100 w-full gap-1">
      <div className="col-start-start bg-white w-full shadow-xs px-3 sm:px-5 pt-2 pb-6">
        {/* greeting */}
        <div className="col-start-start gap-2 py-4">
          <span className="text-lg font-semibold text-slate-800 leading-none">
            Let's eat
          </span>
          <span className="text-slate-700 text-xl leading-none">
            {" "}
            The Tastiest Food{" "}
          </span>
        </div>

        {/* location */}
        <div className="col-center-center w-full pb-2">
          <div className="row-between-center w-full bg-stone-100 py-1 pl-2 pr-1 rounded">
            <span className="text-slate-500 min-w-[9rem]">
              Pilih Lokasi Anda
            </span>

            <Dropdown
              className="border-slate-300 w-full"
              value={appContext.selectedKota}
              onChange={(e) => appContext.setSelectedKota(e.value)}
              options={appContext.listKota}
              optionLabel="nama"
              placeholder="Pilih Kota"
              checkmark={true}
              highlightOnSelect={false}
              pt={{
                input: { className: "text-sm text-slate-500 font-semibold" },
              }}
            />
          </div>
        </div>

        {/* search  */}
        <SearchInputText
          loading={loading}
          autofocus={false}
          value={filterText}
          placeholder="Find Your Favourite Food"
          onChange={(_text) => setFilterText(_text)}
          onSearch={(text) => handleSearch(text)}
          onClick={() => {
            navigate("/list-produk");
          }}
        />
      </div>

      {/* recommended  */}
      <div className="col-start-start bg-white w-full shadow-xs px-3 sm:px-5 py-4 gap-4">
        <div className="row-between-center w-full">
          <span className="text-sm text-slate-600 font-semibold">
            Recommended
          </span>
          <Link
            className="text-slate-600 font-semibold text-sm"
            to="/list-produk"
          >
            See All
          </Link>
        </div>
        <div className="row-start-start w-full gap-1 overflow-x-auto gap-x-2">
          {listRecommended.map((item, index) => (
            <ProductBox key={`recommended-${item.id}`} {...item} />
          ))}
        </div>
      </div>

      {/* toko  */}
      <div className="col-start-start bg-white w-full shadow-xs px-3 sm:px-5 py-4 gap-4">
        <div className="row-between-center w-full">
          <span className="text-sm text-slate-600 font-semibold">
            Restaurants / Toko
          </span>
          <Link
            className="text-slate-600 font-semibold text-sm"
            to="/list-toko"
          >
            See All
          </Link>
        </div>
        <div className="row-start-start w-full gap-1 overflow-x-auto gap-x-2">
          {listToko.map((item, index) => (
            <TokoBoxSmall {...item} />
          ))}
        </div>
      </div>

      {/* kategori  */}
      <div className="col-start-start bg-white w-full shadow-xs px-3 sm:px-5 py-4 gap-4">
        <div className="row-between-center w-full">
          <span className="text-sm text-slate-600 font-semibold">Kategori</span>
          <Link
            className="text-slate-600 font-semibold text-sm"
            to="/list-kategori"
          >
            See All
          </Link>
        </div>
        <div className="row-start-start w-full gap-x-3 gap-y-4 flex-wrap">
          {listKategori.map((item, index) => (
            <KategoriBox key={`kategori-${item.id}`} {...item} />
          ))}
        </div>

        {/* blank space */}
        <div className="h-[0rem]" />
      </div>
    </div>
  );
};

export default HomePage;
